const YOUTUBE_ID_PATTERN =
    /^(?:https?:\/\/)?(?:www\.|m\.|music\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)|youtube-nocookie\.com\/embed\/|youtu\.be\/)([\w-]{11})(?:[?&#/].*)?$/i

/**
 * Mirrors SiaCulturaInstitucionalMaterial::extractYoutubeId() on the backend.
 *
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export function getYouTubeId(url) {
    if (!url) return null
    const m = String(url).trim().match(YOUTUBE_ID_PATTERN)
    return m ? m[1] : null
}

/**
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export function getYouTubeEmbedSrc(url) {
    if (!url) return null
    const legacy = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})/)
    const id = getYouTubeId(url) || (legacy ? legacy[1] : null)
    return id ? `https://www.youtube.com/embed/${id}` : null
}

/**
 * @param {string} id
 * @returns {string}
 */
export function getYouTubeThumbnail(id) {
    return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
}
